"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const QuoteWidget_1 = __importDefault(require("./QuoteWidget"));
exports.default = QuoteWidget_1.default;
